<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->
<template>
  <g>
    <path
      d="M17.0789 7.02652C17.0789 9.74434 14.8757 11.9476 12.1579 11.9476C9.44005 11.9476 7.23682 9.74434 7.23682 7.02652C7.23682 4.3087 9.44005 2.10547 12.1579 2.10547C14.8757 2.10547 17.0789 4.3087 17.0789 7.02652Z"
      fill="#211E1E"
    />
    <path
      d="M13.0526 20.8946H5C4.99972 19.802 5.24956 18.7239 5.73037 17.7428C6.21118 16.7617 6.91021 15.9037 7.77388 15.2345C8.63755 14.5653 9.64295 14.1027 10.713 13.8822C11.4846 13.7232 12.2751 13.693 13.0526 13.791V20.8946Z"
      fill="#211E1E"
    />
    <path d="M17.5263 16.421V13.7368H19.3158V16.421H22V18.2105H19.3158V20.8947H17.5263V18.2105H14.8421V16.421H17.5263Z" fill="#211E1E" />
    <path d="M17.5263 16.421V13.7368H19.3158V16.421H22V18.2105H19.3158V20.8947H17.5263V18.2105H14.8421V16.421H17.5263Z" fill="#0CC177" />
  </g>
</template>
